import { render, staticRenderFns } from "./AreaGroup.vue?vue&type=template&id=3072acbe&scoped=true&"
import script from "./AreaGroup.vue?vue&type=script&lang=js&"
export * from "./AreaGroup.vue?vue&type=script&lang=js&"
import style0 from "./AreaGroup.vue?vue&type=style&index=0&id=3072acbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072acbe",
  null
  
)

export default component.exports